import { Box, IconButton } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"
import React from "react"

import { EquivalencyTypeChip } from "../components/EquivalencyTypeChip"
import EquivalentProductGroupRowActions from "../components/EquivalentProductGroupRowActions"

import type { EquivalencyGroup } from "@/graphql/codegen/graphql"

interface UseEquivalentProductGroupsColumnsProps {
  onEdit?: (group: EquivalencyGroup) => void
  onDelete?: (equivalencyGroupId: string, groupName: string) => Promise<boolean>
}

export const useEquivalentProductGroupsColumns = ({
  onEdit,
  onDelete,
}: UseEquivalentProductGroupsColumnsProps = {}): ColumnDef<EquivalencyGroup>[] => {
  return [
    {
      accessorKey: "name",
      header: "Group Name",
      sortingFn: "alphanumeric",
      cell: ({ row }) => <div className='flex grow items-center'>{row.original.name}</div>,
      enableSorting: true,
    },

    {
      accessorKey: "type",
      header: "Group Equivalent Type",
      sortingFn: "alphanumeric",
      cell: ({ row }) => (
        <div className='flex items-center'>
          <EquivalencyTypeChip type={row.original.type} />
        </div>
      ),
      enableSorting: true,
    },
    {
      accessorKey: "actions",
      header: "",
      size: 112,
      enableSorting: false,
      cell: ({ row }) => (
        <Box className='flex items-center justify-end gap-x-3'>
          <EquivalentProductGroupRowActions row={row} onEdit={onEdit} onDelete={onDelete} />
          <IconButton size='small' onClick={row.getToggleExpandedHandler()}>
            {row.getIsExpanded() ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
          </IconButton>
        </Box>
      ),
    },
  ]
}
